import { Decimal } from "../../decimal";
import { DatabaseId } from "../../types/helpers/Id";
import { ValueAssetsResponse } from "../../types/responses/ValueAssetsResponse";

export class AssetValueService {
  public readonly baseAsset: { _id: DatabaseId };
  public readonly valueDate: Date;
  private readonly _rateLookup: Map<string, Decimal>;

  constructor({ baseAsset, valueDate, rates }: ValueAssetsResponse) {
    this.baseAsset = baseAsset;
    this.valueDate = valueDate;
    this._rateLookup = new Map(
      rates.map(({ asset: { _id }, rate }) => [_id.toString(), rate]),
    );
  }

  public getValue(props: {
    asset: { _id: DatabaseId };
    amount: Decimal;
  }): Decimal | undefined {
    const rate = this._rateLookup.get(props.asset._id.toString());
    if (!rate) return undefined;

    return props.amount.times(rate);
  }
}
